const assignedUserStyle = {
  smallFont: {
    fontSize: 10,
  },
};

export default assignedUserStyle;
